<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="12" :sm="24">
        <categories-manager
          :app="app"
          :categories="billingCategories"
          type="BillingCategory"
          title="Billing Categories"
        />
      </el-col>
      <el-col :md="12" :sm="24">
        <categories-manager
          :app="app"
          :categories="ptoCategories"
          type="PtoCategory"
          title="PTO Categories"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import CategoriesManager from '@/components/category/CategoriesManager';

  export default {
    name: 'TimeclockSettings',
    props: {
      app: {
        required: true,
      },
    },
    components: {
      categoriesManager: CategoriesManager,
    },
    data() {
      return {
        activeNames: ['billingCategories'],
      };
    },
    computed: {
      billingCategories() {
        return this.$store.getters['entities/categories/query']()
          .where('type', 'BillingCategory')
          .get();
      },

      ptoCategories() {
        return this.$store.getters['entities/categories/query']()
          .where('type', 'PtoCategory')
          .get();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/app/TimeclockSettings.vue